import { filter, forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ProductsService } from 'src/app/services/products.service';
import { WebinarService } from 'src/app/services/shared/webinar.service';
import { Logger } from 'html2canvas/dist/types/core/logger';
import { RssfeedsService } from '../rssfeeds.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DasboardService } from 'src/app/services/super-admin/dasboard.service';
import { FilterPayload } from 'src/app/models/product-model';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss']
})
export class LandingpageComponent implements OnInit {
  items: any[] = [];
  rows: any[] = [];
  maxCards: number = 5;
  products: any[] = [];
  upcomingWebinars: any[] = [];
  specifications: any[] = [];
  itemsToDisplay: number = 5;
  counter: boolean = false;
  manufacturersCount: number = 0;
  distributorsCount: number = 0;
  healthcareCount: number = 0;
  customersCount: number = 0;
  desktop: boolean = false;
  originalTruncateText: number = 24;
  endCustomerFilter:any = {
    continent:[],
    country: [],
    state: [],
    city: [],
    createdBy:[],
    accountId: [],
    specialityId: [],
    positionId: [],
    emailVerified: null,
    status: null,
    createdStartDate: null,
    createdEndDate: null
  }

  constructor(
    private rssfeedsService: RssfeedsService,
    private breakpointObserver: BreakpointObserver,
    private spinner: SpinnerService,
    private superAdminDashboardService: DasboardService,
    private productsService: ProductsService, private router: Router, private webinarService: WebinarService, private endCustomerService: EndCustomerService ) {
    this.items = Array.from({ length: 12 }, (_, i) => i);
    this.rows = this.groupItems(this.items, 5);
  }
  
   async ngOnInit() {
    this.ShowItemsBasedonScreenSize2();
    const url = new URL(this.router.url, window.location.href);
    const domain = url.hostname;
    if(domain === 'https://medworldexpo.com/'){
      this.counter = true;
    }
    this.editIframe();
    
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
        topOfPage.scrollIntoView({ behavior: 'smooth' });
      } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    window.scroll(0, 0);
    this.spinner.showSpinner();
     await this.getWebinars();
    await this.getTopProducts();
    await this.getNewsAndTrends();
    this.spinner.hideSpinner();

  const filterPayload: FilterPayload = {
    continents: [],  
    countries: [],     
    states: [],       
    cities: [],       
    startDate:'', 
    endDate: '',    
  };

  this.getSummaryData(filterPayload);

  
}
resetScrollSettings(): void {
  setTimeout(() => {
    const body = document.body;
    const html = document.documentElement;

    body.style.overflow = 'auto';
    html.style.overflow = 'auto';
  });
}
ShowItemsBasedonScreenSize2() {
  this.breakpointObserver.observe([
    "(min-width: 1390px)",
    "(min-width: 1302px) and (max-width: 1390px)",
    '(max-width: 768.98px)'
  ]).subscribe((result: any) => {
    if (result.matches) {
     if (result.breakpoints["(min-width: 1390px)"]) {
        this.originalTruncateText = 45;
      }
      else if (result.breakpoints["(min-width: 1302px) and (max-width: 1390px)"]) {
        this.originalTruncateText = 35;
      }
      if (result.breakpoints['(max-width: 768.98px)']) {
       this.resetScrollSettings();
      }
    }
  });
}

  editIframe(){
    const iframe = document.getElementsByTagName('iframe');
  }


  getSummaryData(filterPayload: FilterPayload) {
    forkJoin([
      this.superAdminDashboardService.getOEMSSummary(filterPayload),
      this.superAdminDashboardService.getDistributorsSummary(filterPayload),
      this.endCustomerService.endCustomerWithSearchKeyword(this.endCustomerFilter, ''),
      this.superAdminDashboardService.getProductsSummary()
    ]).subscribe(([oemSummary, distributorSummary, endCustomerSummary, products]) => {

      this.manufacturersCount = oemSummary?.data?.publishedOEMs ?? 0;
      this.distributorsCount = distributorSummary?.data?.publishedDistributors ?? 0;
      this.healthcareCount = (
        (endCustomerSummary?.data?.['totalEndCustomers'] ?? 0) )
      this.customersCount=products?.data?.['totalProductsCount'] ?? 0;
    
    });
  }

  ShowItemsBasedonScreenSize() {
    this.breakpointObserver.observe([
      '(min-width: 1550px)',
      '(min-width: 1449px) and (max-width: 1549px)',
      '(min-width: 1051px) and (max-width: 1449px)',
      '(min-width: 799px) and (max-width: 1050px)',
      '(max-width: 798px)'
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints['(min-width: 1550px)']) {
          this.itemsToDisplay = 10;
          this.desktop = true;
        } else if (result.breakpoints['(min-width: 1449px) and (max-width: 1549px)']) {
          this.itemsToDisplay = 10;
          this.desktop = false;
        } else if (result.breakpoints['(min-width: 1051px) and (max-width: 1449px)']) {
          this.itemsToDisplay = 8;
        } else if (result.breakpoints['(min-width: 799px) and (max-width: 1050px)']) {
          this.itemsToDisplay = 6;
        } else if (result.breakpoints['(max-width: 798px)']) {
          this.itemsToDisplay = 10;
        }
      }
    });
  }

  rssData: any;
   async getNewsAndTrends(): Promise<void> {
    this.rssfeedsService.fetchAndParseRssFeed('topstories').then((res: any) => {
      this.rssData = res;
    })
   }

 async getTopProducts(): Promise<void> {
    this.productsService.getTopProducts('LatestProducts').subscribe((res: any) => {
      this.products = res.data;
      this.ShowItemsBasedonScreenSize();
      this.products?.forEach((product: any) => {
        const productSpecs: any[] = [];
        product.specifications?.forEach((spec: any) => {
          if (spec.isRange === 'false') {
            productSpecs.push({
              name: spec.name,
              value: spec.fromValue+' '+spec.fromUnit
            });
          } else {
            productSpecs.push({
              name: spec.name,
              value: `${spec.fromValue} ${spec.fromUnit} - ${spec.toValue} ${spec.fromUnit}`
            });
          }
        });
        this.specifications = productSpecs.slice(0, 3);
      });
    });
  }

async getWebinars(): Promise<void> {
  this.webinarService.filters({}).subscribe((res: any) => {
    if (!res || !res.data) return;
    
    const webinars = res.data;
    const currentDate = new Date();
    const upcomingWebinars = webinars.filter((webinar: any) => {
      if (!webinar.webinarDate) return true;
      return new Date(webinar.webinarDate) >= currentDate;
    });
    this.upcomingWebinars = upcomingWebinars.sort((a: any, b: any) => {
      if (a.sponsored !== b.sponsored) {
        return a.sponsored ? -1 : 1;
      }
      const aHasDate = !!a.webinarDate;
      const bHasDate = !!b.webinarDate;
      
      if (aHasDate !== bHasDate) {
        return aHasDate ? 1 : -1;
      }

      if (aHasDate && bHasDate) {
        const dateA = new Date(a.webinarDate);
        const dateB = new Date(b.webinarDate);
        
        if (dateA.getTime() !== dateB.getTime()) {
          return dateA.getTime() - dateB.getTime();
        }
        
        if (a.webinarTime && b.webinarTime) {
          const timeA = this.parseTime(a.webinarTime);
          const timeB = this.parseTime(b.webinarTime);
          return timeA - timeB;
        }
      }
      return 0;
    });
  });
}
  parseTime(time: string): number {
    const [hours, minutesPart] = time.split(':');
    const [minutes, period] = minutesPart.split(' ');
    let totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
  
    if (period.toUpperCase() === 'PM' && parseInt(hours) !== 12) {
      totalMinutes += 12 * 60;
    } else if (period.toUpperCase() === 'AM' && parseInt(hours) === 12) {
      totalMinutes -= 12 * 60;
    }
  
    return totalMinutes;
  }

  view(id: any){
    this.router.navigate(['/webinars/view', id]);
  }

  groupItems(items: any[], itemsPerRow: number): any[][] {
    this.ShowItemsBasedonScreenSize();
    const rows = [];
    for (let i = 0; i < items.length; i += itemsPerRow) {
      rows.push(items.slice(i, i + itemsPerRow));
    }
    return rows;
  }

  redirectToNews(newsLink: any) {
    window.open(newsLink,'_blank');
  }

  navigateToProductsView() {
    this.router.navigate(['/products-view'], {state: {isViewAll: true}});
  }

  navigateTo4DDemo() {
    window.open('https://seventh-reality.github.io/Electric-Bed/', '_blank');
  }

}